import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import ActionButton from 'components/ActionButton';
import { AlertButtons } from 'assets/styles/sharedStyles';
import { setLoyaltyUser } from 'actions/loyalty';

const AuraSignOut = ({ closeAlert, dispatch, setPage }) => {
  const handleSignOut = async () => {
    const res = await fetch(`/api/loyalty/user/sign_out`, {
      method: 'POST',
    });

    if (res.ok) {
      dispatch(setLoyaltyUser());
      setPage('signOutConfirmation');
    }
  };

  return (
    <>
      <FormattedMessage defaultMessage="Are you sure you'd like to sign out of your Aura account?" />
      <AlertButtons>
        <ActionButton
          dangerButton={true}
          label={<FormattedMessage defaultMessage="Cancel" />}
          onClick={closeAlert}
        />
        <ActionButton label={<FormattedMessage defaultMessage="Sign Out" />} onClick={handleSignOut} />
      </AlertButtons>
    </>
  );
};

AuraSignOut.propTypes = {
  setPage: PropTypes.func,
  closeAlert: PropTypes.func,
  dispatch: PropTypes.func,
};

export default connect()(AuraSignOut);
